<template>
	<RouterLink class="flex items-center gap-1 text-blue-500 group" :to>
		<span
			v-if="icon && !iconAfter"
			class="ht-icon text-[1rem] duration-100 group-hover:-translate-x-1"
		>
			{{ icon }}
		</span>
		<span class="text-sm group-hover:underline">
			<slot />
		</span>
		<span
			v-if="icon && iconAfter"
			class="ht-icon text-[1rem] duration-100 group-hover:translate-x-1"
		>
			{{ icon }}
		</span>
	</RouterLink>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from "vue-router";

defineProps<{
	to: RouteLocationRaw;
	icon?: string;
	iconAfter?: boolean;
}>();
</script>
